// extracted by mini-css-extract-plugin
export default {"kb":"kb-general_kb__aHiIn","content":"kb-general_content__O5tWX","header":"kb-general_header__bNOjB","modules":"kb-general_modules__1hatS"};